import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from '../Loader/Loader';
import styles from './styles.module.scss';
const Button = ({ type, disabled, title, onClick, loader, value, className = 'bg-color-primary color-light', icon, style }) => {
    return (_jsx("button", Object.assign({ style: style, type: type, title: title, disabled: disabled, onClick: onClick, className: `${styles.btn} ${className} flex justify-content-center align-items-center` }, { children: loader ? (_jsx(Loader, { sm: true })) : (_jsxs(_Fragment, { children: [value, icon] })) })));
};
export default Button;
